export default __webpack_public_path__ + "static/media/chrome.c857d135.gif";